import axios from 'axios';

const request = () => window.axios || axios;

const buildBasePath = accountId =>
  `/api/v1/accounts/${accountId}/integrations/tienda_nube`;

export const fetchTiendaNubeState = accountId =>
  request().get(buildBasePath(accountId));

export const authorizeTiendaNube = accountId =>
  request().post(`${buildBasePath(accountId)}/auth`);

export const fetchTiendaNubeOrders = (accountId, contactId) =>
  request().get(`${buildBasePath(accountId)}/orders`, {
    params: { contact_id: contactId },
  });

export const fetchTiendaNubeAllOrders = (accountId, params = {}) =>
  request().get(`${buildBasePath(accountId)}/all_orders`, { params });

export const fetchTiendaNubeAbandonedCheckouts = (accountId, params = {}) =>
  request().get(`${buildBasePath(accountId)}/abandoned_checkouts`, { params });
